import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { SplitScreenState } from '../components/project-split-screen/project-split-screen.component';

@Injectable({ providedIn: 'root' })
export class ProjectSplitScreenService {
    splitScreenStateChange$: ReplaySubject<SplitScreenState> =
        new ReplaySubject<SplitScreenState>();
}
